import { FormattedMessage, useIntl } from "react-intl";
import IQBOSyncInvoicesUpdateDTO from "../../../models/DTO/IQBOSyncInvoicesUpdateDTO";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = { progress: IQBOSyncInvoicesUpdateDTO | null };

export default function QboInvoicesSyncStatus({ progress }: Props) {
    const intl = useIntl();
    const total = Math.max(0, progress?.totalItems ?? 0);
    const processed = Math.max(0, progress?.totalProcessed ?? progress?.startPosition ?? 0);
    const percent = total > 0 ? Math.min(100, (processed / total) * 100) : 0;
    return (
        <div className="mb-2" style={{ width: "20rem", maxWidth: "100%" }} role="status" aria-live="polite">
            <div className="d-flex align-items-center gap-2">
                <i className="far fa-circle-notch fa-spin" aria-hidden="true" />
                <strong>
                    <FormattedMessage id="importing_quickbooks_online_invoices" defaultMessage="Importing QuickBooks Online invoices" />
                </strong>
            </div>
            {progress ? (
                <div>
                    <OwLabel title="processing" noBottomMargin postText=":" className="me-2" />
                    {processed} <OwLabel title="of" noBottomMargin /> {total}
                </div>
            ) : (
                <div>
                    <FormattedMessage id="waiting_for_invoice_totals" defaultMessage="Waiting for invoice totals…" />
                </div>
            )}
            <div
                className="mt-2"
                role="progressbar"
                aria-label={intl.formatMessage({ id: "invoice_import_progress", defaultMessage: "Invoice import progress" })}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={total > 0 ? percent : undefined}>
                <div className="bg-warning" style={{ height: "3px", width: `${percent}%` }} />
            </div>
        </div>
    );
}
